<template>
    <div ref="scollElement">
        <div class="header" >
      <div class="topbar" style="margin: 0 15vw;">
        <img src="../assets/img/homepage/logotop.png" />
        <myheader></myheader>
      </div>
      <div class="maindiv1">
          <div>
            <span class="mainsp2">为印染行业精益生产而生的专业化管理软件</span><br />
            <span class="mainsp1">TMIP®纺织印染</span>
            <span class="underline"></span>
          </div>
          <img style="margin-left:400px;" src="../assets/img/homepage/toprightlogo.png" />
        <!-- <div class="mainbtn">
          <i class="iconfont iconzu1250"></i>咨询热线：0513-81193001
        </div> -->
      </div>
      
    </div>
    <!-- 产品简介 -->
    <div class="maindiv2">
          <div style="width:700px;"> 
              <span class="mainsp3">产品简介</span>
              <span class="mainsp4">针对纺织印染企业的生产过程排程、生产、质量、订单、采购、库存等核心场景，在多产品、
                <br />
                    不同工艺参数、不同染化料配方、不同工序路线的复杂生产需求下，结合企业设备产能实绩，
                <br />
                    帮助企业达成生产可视化、过程规范化、生产可追溯、管理精益化的现代化管理要求。
              </span>
              <img style="margin-top:30px;" src="../assets/img/homepage/introduce.png">
          </div>
          <img style="margin-left:100px;" src="../assets/img/homepage/managegoal.png" />
    </div>
    <!-- 功能全览 -->
    <div class="maindiv3">
        <div style="text-align:center;">
            <span class="mainsp3">功能全览</span>
            <span class="mainsp4">以采购为源头、涉及销售、生产、工艺（技术）、品质、仓储等，搭建信息化管理基础框架。</span>
            
            <span class="mainsp4">建立信息化管理流程，为精益管理奠定了良好的信息化基础</span>
        </div>
        <div style="text-align:center;margin-top:30px;">
           <img  src="../assets/img/homepage/function.png">
        </div>
    </div>
    <!-- 精细化管理 -->
    <div class="maindiv3" style="background-color: #F2F6F9;">
        <div style="text-align:center;">
            <span class="mainsp3">精细化管理</span>
            <span class="mainsp4">指以生产最小批次（“Lot”、“卡号”、“缸号”等）为单位的管理。系统从退卷工序开始，记录各工序流转实绩，</span>
            
            <span class="mainsp4">直到质检、入库、出库。支持以批次为单位追溯原料、生产、品质等情况</span>
        </div>
        <div style="text-align:center;margin-top:30px;">
           <img  src="../assets/img/homepage/detailmanage.png">
        </div>
    </div>
    <!-- 配方管理 -->
    <div class="maindiv2" style="background-color: #Fff;">
          <div style="width:700px;"> 
              <span class="mainsp3">配方管理</span>
              <span class="mainsp4">包括打样配方管理、染色配方管理、一般工程配方管理</span>
              <span class="mainsp5">打样配方管理</span>
              <img style="margin-top:10px;" src="../assets/img/homepage/sample.png">
              <span class="mainsp5">染色配方管理</span>
              <img style="margin-top:10px;" src="../assets/img/homepage/dyeing.png">
              <span class="mainsp5">一般工程配方管理</span>
              <img style="margin-top:10px;" src="../assets/img/homepage/common.png">
          </div>
          <img style="margin-left:100px;" src="../assets/img/homepage/formula.png" />
    </div>
    <!-- 生产排程 -->
    <div class="maindiv2">
          <div style="width:700px;"> 
              <span class="mainsp3">生产排程</span>
              <span class="mainsp4">全面管理加工流程、生产工艺，结合订单交期、品种、颜色及实际设备
                <br />
                    加工能力等多种因素，智能辅助机台作业排程，进而实现厂内生产资源
                <br />
                    合理调配，提高产能，保障交货期
              </span>
              <img style="margin-top:10px;" src="../assets/img/homepage/production.png">
          </div>
          <img style="margin-left:100px;" src="../assets/img/homepage/Scheduling.png" />
    </div>
    <!-- 工艺监控 -->
    <div class="maindiv2" style="background-color: #Fff;">
          <div style="width:700px;"> 
              <span class="mainsp3">工艺监控</span>
              <span class="mainsp4">建立标准工艺库，设定各工序工艺参数，对生产过程中设备状态实时监
                <br />
                    控，确保加工参数与工艺条件吻合，提高生产质量
              </span>
              <br />
              <span class="mainsp4">生产过程中，通过条码采集终端、工业平板等设备采集加工实绩，实时
                <br />
                    比对，及时告警
              </span>
              <br />
              <span class="mainsp4">提高设备使用效能，为产品质量追溯提供数据基础</span>
              <img style="margin-top:10px;" src="../assets/img/homepage/workmanship.png">
          </div>
          <img style="margin-left:100px;" src="../assets/img/homepage/monitor.png" />
    </div>
    <!-- 成本核算 -->
    <div class="maindiv2" >
          <div style="width:700px;"> 
              <span class="mainsp3">成本核算</span>
              <span class="mainsp4">精准把握加工过程中的工艺流程、设备耗费、原料价格、辅料耗材、产量
                <br />
                    构成等信息，根据实际生产状态（良品率、返修率等），归集企业各项成
                <br />
                    本费用，一键成本核算相关产品价格
              </span>
              <br />
              <span class="mainsp4">核算精准可靠，及时反馈各品种成本变化曲线</span>
              <img style="margin-top:10px;" src="../assets/img/homepage/cost.png">
          </div>
          <img style="margin-left:100px;" src="../assets/img/homepage/account.png" />
    </div>
    </div>
</template>

<script>
import util from "../components/util";
import Swiper from "swiper";
export default util.useCommon({
    data() {
        return {

        }
    },
    methods: {}
})
</script>

<style lang="less" scoped>

.header {
  background-image: url(../assets/img/homepage/bg123.jpg);
  min-width: 1300px;
  height: 460px; 
}
.maindiv1 {
  // text-align: center;
  padding-top: 89px;
  padding-left: 15vw;
  display: flex;
}
.mainsp1 {
  font: normal normal normal 46px/56px Microsoft YaHei;
  letter-spacing: 0px;
  color: #ffffff;
  opacity: 1;
}
.mainsp2 {
  font: normal normal 300 24px/56px Microsoft YaHei;
  letter-spacing: 0px;
  color: #ffffff;
  opacity: 1;
  display: inline-block;
//   margin: 30px 0 50px 0;
}
.mainbtn {
  font: normal normal normal 18px/56px Microsoft YaHei;
  letter-spacing: 0px;
  color: #ffffff;
  opacity: 1;
  width: 320px;
  margin: 0 auto;
  background-color: #537bfe;
  border-radius: 27px;
  overflow: hidden;
  cursor: default;
}

.iconzu1250 {
  margin-right: 10px;
  font-size: 20px;
  position: relative;
  top: 2px;
}

.maindiv2 {
//   padding-top: 150px;
//   padding-left: 21vw;
  display: flex;
  padding: 62px 15vw;
  background-color: #F2F6F9;
}
.maindiv3 {
  padding: 62px 15vw ;
}
.mainsp3 {
  font: normal normal normal 28px Microsoft YaHei;
  letter-spacing: 0px;
  color: #000000;
  display: block;
  margin-bottom: 10px;
}
.mainsp4 {
  font: normal normal normal 15px/32px Microsoft YaHei;
  letter-spacing: 0px;
  color: #717B81;
  display: block;  
}
.mainsp5 {
  display: block;
  font: normal normal bold 18px Source Microsoft YaHei;
  letter-spacing: 0px;
  color: #262727;
  font-weight: bold;
}
.maindiv4 {
  padding-top: 30px;
}




@keyframes fade-in {  
    0% {opacity: 0;}/*初始状态 透明度为0*/  
    30% {opacity: 0.5;}
    50% {opacity: 0.7;}/*过渡状态 透明度为0*/  
    80% {opacity: 0.8;}
    100% {opacity: 0.9;}/*结束状态 透明度为1*/  
}  
@-webkit-keyframes fade-in {/*针对webkit内核*/  
    0% {opacity: 0;}  
    30% {opacity: 0.5;}
    50% {opacity: 0.7;}  
    80% {opacity: 0.8;}
    100% {opacity: 0.9;}  
}  







.textleft{
  text-align: left;
  display: block;
}
.underline{
    width: 127px;
    display: block;
    height: 2px;
    background-color: #fff;
    margin-top: 15px;
}



</style>
